import { Injectable } from '@angular/core';
import { SERVER_API_URL } from '../app.constants';
import { HttpClient } from '@angular/common/http';
import { ParamContext } from '../shared/service/param.context';
import { Observable } from 'rxjs';
import { AnalyzedTraitModel } from './analyzed-trait.model';
import { MultiSiteAnalysisInputModel } from './multi-site-analysis-input.model';

@Injectable()
export class MultiSiteAnalysisService {
    private baseUrl = SERVER_API_URL;

    constructor(
        private http: HttpClient,
        private paramContext: ParamContext
    ) {
    }

    getAnalyzedTraits(studyId: number, meansDatasetId: number): Observable<AnalyzedTraitModel[]> {
        const resourceUrl =
            `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/multi-site-analysis/analyzedTraits/${meansDatasetId}`;
        return this.http.get<AnalyzedTraitModel[]>(`${this.baseUrl + resourceUrl}`);
    }

    download(studyId: number, input: MultiSiteAnalysisInputModel) {
        const resourceUrl = `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/multi-site-analysis/export`;
        return this.http.post(`${this.baseUrl + resourceUrl}`, input,
            {
                responseType: 'blob',
                observe: 'response'
            }
        );
    }
}
